import { ScreenSize } from '../../../../hooks/common/constants.tsx';

export const LabelType = {
	VERSION: 'version',
	EPIC: 'epic',
	STATUS: 'status',
} as const;
export type LabelType = (typeof LabelType)[keyof typeof LabelType];
export const getLabelWidthMultiplier = (
	labelType: LabelType,
	containerWidth: ScreenSize | undefined,
) => {
	switch (containerWidth) {
		case ScreenSize.EXTRA_SMALL: {
			if (labelType === LabelType.VERSION) {
				return 3;
			}
			if (labelType === LabelType.EPIC) {
				return 3;
			}
			return 12.5;
		}
		case ScreenSize.SMALL: {
			if (labelType === LabelType.VERSION) {
				return 3;
			}
			return 12.5;
		}
		case ScreenSize.MEDIUM: {
			return 18.75;
		}
		case ScreenSize.LARGE: {
			return 18.75;
		}
		case ScreenSize.EXTRA_LARGE: {
			return 25;
		}
		default:
			return 12.5;
	}
};
